import axios from 'axios';
import { EnvironmentConfig } from '../constants.js';

export default {
    name: 'USBRGAAPService',
    data() {
        return {
            baseApiUrl: '',
            APIKey: ''
        }
    },
    created: function () {
        //URL and endpoint constants
        this.baseApiUrl = EnvironmentConfig._baseURL;
        this.APIKey = EnvironmentConfig._APIURL;
    },
    methods: {
        SaveFileDetails(saveJsonArray) {
            const saveFileUrl = this.baseApiUrl + '/api/TaxTransformation/SaveFile';
            return axios({
                method: 'post',
                url: saveFileUrl,
                headers: {
                    'APIKey': this.APIKey,
                    'Authorization': 'Bearer ' + localStorage.getItem('JWTToken')
                },
                data: saveJsonArray
            })
                .then(function (responseSave) {
                    if (responseSave) {
                        return responseSave;
                    }
                }).catch((error) => {
                    return error;
                });
        }
    }
}

